// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3KnO5"};